"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const joi_1 = __importDefault(require("joi"));
const GenericValidator_1 = __importDefault(require("./GenericValidator"));
class RegisterBindingValidator extends GenericValidator_1.default {
    schema = joi_1.default.object({
        sc1TplGuid: joi_1.default.string().required(),
        sc1CustomerId: joi_1.default.number().required(),
        oc1OrgKey: joi_1.default.string().required(),
        oc1TplGuid: joi_1.default.string().required(),
        oc1CustomerId: joi_1.default.number().required(),
        delete: joi_1.default.boolean().required(),
    }).required();
    validate(input) {
        super.validate(input, 'IRegisterBinding', this.schema);
    }
}
exports.default = RegisterBindingValidator;
